export default {
    CONNECTION_CLOSE_WARNING: "Соединение с сервером было разорвано.",
    CONNECTION_RETRY_INFO: "Попытка восстановить соединение с сервером",
    CONNECTION_RETRY_SUCCESS: "Соединение с сервером восстановлено",
    RECONNECT: "Переподключиться"
};
